import * as React from 'react';
import PropTypes from 'prop-types';
import { Field, Form } from 'react-final-form';
import {
    Button,
    CardActions,
    CircularProgress,
    TextField,
} from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslate, useLogin, useNotify, useSafeSetState } from 'ra-core';
import { DataProviderContext } from "react-admin";
import { useContext, useEffect } from "react";
import { bleudineAuthApi } from '../../api/bleudineAuthApi';
import { userApi } from '../../api/userApi';
import useAuth from '../../auth/useAuth';

const useStyles = makeStyles(
    (theme) => ({
        form: {
            padding: '0 1em 1em 1em',
        },
        input: {
            marginTop: '1em',
        },
        button: {
            width: '100%',
        },
        icon: {
            marginRight: theme.spacing(1),
        },
    }),
    { name: 'RaLoginForm' }
);

const Input = ({
    meta: { touched, error }, // eslint-disable-line react/prop-types
    input: inputProps, // eslint-disable-line react/prop-types
    ...props
}) => (
    <TextField
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />
);


const CustomLogin = (props) => {
    const { redirectTo } = props;
    const { clearAuth, updateAuth } = useAuth();
    const [loading, setLoading] = useSafeSetState(false);
    const login = useLogin();
    const translate = useTranslate();
    const notify = useNotify();
    const classes = useStyles(props);
    const dataProvider = useContext(DataProviderContext);

    const validate = (values) => {
        const errors = { username: undefined, password: undefined };

        if (!values.username) {
            errors.username = translate('ra.validation.required');
        }
        if (!values.password) {
            errors.password = translate('ra.validation.required');
        }
        return errors;
    };

    // const handleLogout = () => {
    //     setLoading(true);
    //     authProvider.logout().then(ret => {
    //         localStorage.removeItem('bleudine-user');
    //         localStorage.removeItem('auth');
    //         localStorage.removeItem('token');
    //         // window.location.href = "/"
    //         setLoading(false);
    //     }).catch(error => {
    //         setLoading(false);
    //         notify("Fail to logout", "warning");
    //     });
    // }


    // const submit = values => {
    //     setLoading(true);
    //     authProvider.login(values).then(ret => {
    //         dataProvider
    //             .getOne("users", { id: ret.user.uid })
    //             .then(({ data }) => {
    //                 setLoading(false);

    //                 if (data.role != "admin"){
    //                     handleLogout();
    //                     debugger
    //                     notify('Failed to login.', "warning");
    //                 }
    //                 else{
    //                     localStorage.setItem('auth', JSON.stringify(data));
    //                     window.location.href = "/"
    //                 }
    //             })
    //             .catch((error) => {
    //                 notify(error);
    //             });

    //     }).catch(error => {
    //         setLoading(false);
    //         notify(
    //             typeof error === 'string'
    //                 ? error
    //                 : typeof error === 'undefined' || !error.message
    //                     ? 'ra.auth.sign_in_error'
    //                     : error.message,
    //             'warning',
    //             {
    //                 _:
    //                     typeof error === 'string'
    //                         ? error
    //                         : error && error.message
    //                             ? error.message
    //                             : undefined,
    //             }
    //         );
    //     });
    // };

    const handleLogout = () => {
        setLoading(true);
        // if (window.$chatwoot) {
        //     window.$chatwoot.reset()
        // }
        localStorage.removeItem('bleudine-user');
        clearAuth();
        localStorage.removeItem('token');
        // window.location.href = "/"
        setLoading(false);
    }
    const submit = values => {
        const login = {
            emailOrPhone: values.username,
            password: values.password,
        }
        setLoading(true);

        bleudineAuthApi.login(login, 7).then(ret => {
            localStorage.setItem("bleudine-user", JSON.stringify(ret));
            localStorage.setItem("token", ret.token);
            userApi.getUser(ret.id)
                .then(({ user }) => {
                    setLoading(false);
                    // if (window.$chatwoot) {
                    //     window.$chatwoot.reset()
                    // }
                    if (ret.accountType != 1) {
                        handleLogout();
                        debugger
                        notify('Failed to login.', "warning");
                    }
                    else {
                        updateAuth(ret);
                        window.location.href = "/"
                    }
                })
                .catch((error) => {
                    notify(error);
                });


        }).catch(error => {
            setLoading(false);
            notify(
                typeof error === 'string'
                    ? error
                    : typeof error === 'undefined' || !error.message
                        ? 'ra.auth.sign_in_error'
                        : error.message,
                'warning',
                {
                    _:
                        typeof error === 'string'
                            ? error
                            : error && error.message
                                ? error.message
                                : undefined,
                }
            );
        });
    };

    return (
        <Form
            onSubmit={submit}
            validate={validate}
            render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <div className={classes.form}>
                        <div className={classes.input}>
                            <Field
                                id="username"
                                name="username"
                                component={Input}
                                label={translate('ra.auth.username')}
                                disabled={loading}
                                variant="outlined"
                            />
                        </div>
                        <div className={classes.input}>
                            <Field
                                id="password"
                                name="password"
                                component={Input}
                                label={translate('ra.auth.password')}
                                type="password"
                                disabled={loading}
                                autoComplete="current-password"
                                variant="outlined"
                            />
                        </div>
                    </div>
                    <CardActions>
                        <Button
                            style={{ height: 40 }}
                            variant="contained"
                            type="submit"
                            color="primary"
                            disabled={loading}
                            className={classes.button}
                        >
                            {loading && (
                                <CircularProgress
                                    className={classes.icon}
                                    size={18}
                                    thickness={2}
                                />
                            )}
                            {translate('ra.auth.sign_in')}
                        </Button>
                    </CardActions>
                </form>
            )}
        />
    );
};

export default CustomLogin;
